import { ECountry } from 'App/i18n/i18n.types';

export const IS_PRODUCTION =
  process.env.REACT_APP_CURRENT_ENVIRONMENT === 'production';

export const IS_LOCAL = process.env.NODE_ENV === 'development';

export const APPCUESID = 126721;

export const APP_IDS_PER_COUNTRY = {
  [ECountry.ARGENTINA]: {
    production: 9075,
    staging: 7977
  },
  [ECountry.MEXICO]: {
    production: 8539,
    staging: 7660
  },
  [ECountry.BRAZIL]: {
    production: 4190,
    staging: 3810
  }
};
